import { Component, OnInit, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { OrganizationService } from '@http/clients/reporting-app/organization.service';
import { GenericDropdownMultiselectComponent } from 'ngx-lib';
import { FormEditorBase, createValueAccessorProvider } from '../../base/form-editor-base';

@Component({
    selector: 'app-report-organization-form-editor',
    templateUrl: './report-organization-form-editor.component.html',
    styleUrls: ['./report-organization-form-editor.component.scss'],
    providers: [createValueAccessorProvider(ReportOrganizationFormEditorComponent)],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownMultiselectComponent]
})
export class ReportOrganizationFormEditorComponent extends FormEditorBase<number[] | null> implements OnInit {
    readonly = input<boolean>(false);
    labelText = input<string>('Organizations');
    placeholderText = input<string>('Select Organizations');
    hasLabel = input<boolean>(true);
    private suppressSyncEmission = false;
    private hasLoadedItems = false;

    private readonly organizationService = inject(OrganizationService);

    override writeValue(value: number[] | null): void {
        this.selectedValue.set(value ?? undefined);
        if (!this.hasLoadedItems) return;
        this.applySelectionFromValue(value);
    }

    async ngOnInit(): Promise<void> {
        const organizations = await this.organizationService.getAll();
        this.items.set(organizations);
        this.hasLoadedItems = true;
        this.applySelectionFromValue((this.selectedValue() as number[] | null | undefined) ?? null);
    }

    protected override async onEntityTextChange(): Promise<void> {
        return;
    }

    protected override mapSelectedItemsToValue(): number[] | null {
        if (this.suppressSyncEmission) {
            this.suppressSyncEmission = false;
            return (this.selectedValue() as number[] | undefined) ?? null;
        }
        const selected = this.selectedItems() ?? [];
        if (!selected.length) return null;
        return selected.map((item) => Number(item.id));
    }

    protected override mapValueToSelectedItems(value: number[] | null): any[] {
        if (!value?.length) return [];
        const selectedIds = new Set(value.map((id) => Number(id)));
        return (this.items() ?? []).filter((item) => selectedIds.has(Number(item.id)));
    }

    private applySelectionFromValue(value: number[] | null): void {
        this.suppressSyncEmission = true;
        this.selectedItems.set(this.mapValueToSelectedItems(value));
        queueMicrotask(() => {
            this.suppressSyncEmission = false;
        });
    }
}
